import PropTypes from 'prop-types';
import React from 'react';
import { cn } from '../../../utils/helper';

/**
 * The page's main action.
 *
 * Colour, radius, padding, hover and the disabled state all come from
 * `.btn-primary` (utils/tailwind-buttons.js), so this component only decides
 * that a primary button is what gets rendered. `className` still wins over it
 * — Tailwind utilities sit in a later layer than components — which is how
 * callers set their own width.
 *
 * This absorbed the old `CommonButton`, which rendered the same button behind
 * a different set of prop names. `text` and `type` are accepted for the call
 * sites that came from it.
 */
export default function PrimaryButton({
  btnText,
  text,
  children,
  btnType,
  type,
  disabled,
  className,
  ...rest
}) {
  return (
    <button
      {...rest}
      type={type || btnType}
      disabled={disabled}
      className={cn('btn-primary', className)}
    >
      {children ?? btnText ?? text}
    </button>
  );
}

PrimaryButton.propTypes = {
  btnText: PropTypes.node,
  /** Alias for `btnText`, from the buttons that used to be `CommonButton`. */
  text: PropTypes.node,
  children: PropTypes.node,
  btnType: PropTypes.string,
  /** Alias for `btnType`. */
  type: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func
};
